import { AxiosResponse, AxiosRequestConfig } from "axios";
import http from "../../services/http";
import { Store as appState } from "../reducers";
import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { TogglePartResponse } from "../../components/parts/PartsList";
import { ConflictingPartErrorResponse } from "../../components/dialogs/conflictingParts";
import {
	applyParts,
	setConfigurationImages,
	addPrice,
	setImageTimestamp,
	showDialog,
	hideDialog,
	setConfigurationIsDirty
} from "../actions";
import { DialogTypes } from "../../enums/dialogTypes";
import {} from "react-i18next";
import { RemovePartPayload } from "../../services/http/real";
import i18n from "../../i18n";
import { toastMessage } from "../../utils/helpers";

// implement custom error interface to support data types
export interface CustormAxiosError<D> {
	config: AxiosRequestConfig;
	request: any;
	response: AxiosResponse<D>;
}

export default function addPart(
	payload: RemovePartPayload | string
): ThunkAction<Promise<void>, appState, {}, any> {
	return function(dispatch: ThunkDispatch<any, any, any>) {
		return http
			.removePart(payload)
			.then(function addPartOnSuccess(
				response: AxiosResponse<TogglePartResponse>
			) {
				dispatch(applyParts(response.data.PartIds));
				dispatch(setConfigurationImages(response.data.FullImages));
				dispatch(addPrice(response.data.Price));
				dispatch(setImageTimestamp());
				toastMessage(i18n.t("configuration.parts.toastPartRemoved"));
				dispatch(hideDialog());
				dispatch(setConfigurationIsDirty(true));
			})
			.catch(function handeErrorResponse(
				error: CustormAxiosError<ConflictingPartErrorResponse>
			) {
				if (error.response.status === 400) {
					const { data } = error.response;
					if (data.InvalidInputMessage) {
						console.error("A rule exception occured on the server");
						return;
					}

					dispatch(
						showDialog({
							contentType: DialogTypes.removeConflictingPart,
							data,
							title: i18n.t("dialogs.conflictingParts.required.delete-title")
						})
					);
				}

				// assumes error code 500
				console.log("Server responded with status code 500");
			});
	};
}
